import React from 'react'
import { Checkbox as UICheckbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { cn } from '@/lib/utils'

class Checkbox extends React.Component {

  onCheckedChange = () => {
    this.props.onChange({
      value: this.props.value,
      checked: !this.props.checked
    })
  }

  render() {
    // Legacy default was bootstrap's block "checkbox"; callers passing
    // "checkbox checkbox-inline-block" want an inline checkbox. Any other
    // classes pass through.
    const tokens = (this.props.classname || '')
      .split(/\s+/)
      .filter((token) => token && token !== 'checkbox' && token !== 'checkbox-inline-block')
    const inline = (this.props.classname || '').includes('checkbox-inline-block')

    return (
      <Label
        className={cn(
          'cursor-pointer py-1',
          inline ? 'inline-flex align-middle' : 'flex my-2',
          (this.props.label_weight === 'normal') ? 'font-normal' : 'font-bold',
          tokens
        )}
      >
        <UICheckbox checked={!!this.props.checked} onCheckedChange={this.onCheckedChange} />
        {this.props.name}
      </Label>
    )
  }
}

export default Checkbox
